"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// this const must be the same as the one in SyncedListing.php
var SYNC_STATUS;
(function (SYNC_STATUS) {
    SYNC_STATUS[SYNC_STATUS["PENDING"] = 1] = "PENDING";
    SYNC_STATUS[SYNC_STATUS["PROCESSING"] = 2] = "PROCESSING";
    SYNC_STATUS[SYNC_STATUS["SYNCED"] = 3] = "SYNCED";
})(SYNC_STATUS = exports.SYNC_STATUS || (exports.SYNC_STATUS = {}));
// these consts must be the same as the ones in UserService.php
exports.EBAY_CHANNEL = 'eBay';
exports.AMAZON_CHANNEL = 'Amazon';
// this const must be the same as the one in AbstractSeller.php
exports.MAX_INVENTORY_SYNC_TRIES = 15;
